// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"356027a7","453":"ddc23065","732":"b7d219cc","977":"b24ca722"}[chunkId] + ".chunk.js";
};